module.exports = __webpack_public_path__ + "065c58409231400ade84bd832956a835.png";